import styled from '@emotion/styled';
import {
  Button,
  Dialog as _Dialog,
  DialogContent as _DialogContent,
  DialogContentText,
  Divider,
  Typography,
} from '@material-ui/core';
import CloseIcon from '@material-ui/core/SvgIcon/SvgIcon';
import { createElement, FC, Fragment } from 'react';
import { FormattedMessage } from 'react-intl';

import { CreationForShowFragment } from '../../../../generated/graphql';
import { getLatestDeliverable } from '../../../../graphql/creation';
import { SPACING_REGULAR, SPACING_UNIT } from '../../../constant/spacing';
import ImageScreen from '../../primitive/ImageScreen';
import AvatarAndName from '../AvatarAndName';

export interface Props {
  open: boolean;
  onRequestClose: () => void;
  creation: CreationForShowFragment;
  className?: string;
}

const IntentDialog: FC<Props> = ({ open, onRequestClose, creation, className }) => {
  const latestDeliverable = getLatestDeliverable(creation)!;
  return (
    <Dialog open={open} onClose={onRequestClose} className={className} maxWidth={'lg'}>
      <CloseButton color="default" onClick={onRequestClose}>
        <CloseIcon />
      </CloseButton>
      <DialogContent>
        <AvatarAndName user={creation.assignee!} />
        {latestDeliverable.attachedThumbnail && (
          <>
            <SubHeading variant="subtitle2">
              <FormattedMessage id="show_project_page.proposal_list.item.title.thumbnail" />
            </SubHeading>
            <CreativeThumbnail src={latestDeliverable.attachedThumbnail.file.url!} clickable />
            <Divider />
          </>
        )}
        <SubHeading variant="subtitle2">
          <FormattedMessage id="show_project_page.proposal_list.item.title.intent" />
        </SubHeading>
        <DialogIntentText variant="body1">{latestDeliverable.intent}</DialogIntentText>
      </DialogContent>
    </Dialog>
  );
};

const Dialog = styled(_Dialog)({
  margin: SPACING_UNIT * 4,
});

const SubHeading = styled(Typography)({
  margin: SPACING_UNIT,
});

const DialogContent = styled(_DialogContent)({
  minWidth: 500,
  minHeight: 300,
  padding: SPACING_REGULAR,
});

const DialogIntentText = styled(DialogContentText)({
  padding: SPACING_UNIT,
  whiteSpace: 'pre-wrap',
  wordWrap: 'break-word' as any,
  wordBreak: 'break-word',
});

const CloseButton = styled(Button)({
  top: 0,
  right: 0,
  position: 'absolute',
  padding: SPACING_UNIT,
  minWidth: SPACING_UNIT * 3,
  minHeight: SPACING_UNIT * 3,
});

const CreativeThumbnail = styled(ImageScreen)({
  margin: SPACING_UNIT,
  marginLeft: SPACING_REGULAR,
  maxWidth: 300,
  padding: SPACING_UNIT,
});

export default IntentDialog;
